import { useQuery } from "@tanstack/react-query"
import { CanonicalTopicsTimelineQuery } from "../lib/canonicalTopicsTimelineQuery"

export function useCanonicalTopicsTimelineQuery(
  ...args: Parameters<typeof CanonicalTopicsTimelineQuery>
) {
  return useQuery(CanonicalTopicsTimelineQuery(...args))
}
